import Reveal from "./Reveal";
import CtaButton from "./CtaButton";

const FinalCta = () => (
  <section className="px-6 pb-32 pt-20 sm:py-28">
    <div className="mx-auto max-w-2xl text-center">
      <Reveal>
        <h2 className="text-3xl font-extrabold leading-tight tracking-[-0.03em] sm:text-5xl">
          a próxima turma não começa{" "}
          <span className="e21-serif">sem ti</span>.
        </h2>
        <p className="mx-auto mt-5 max-w-md text-base leading-relaxed text-black/60 sm:text-lg">
          essa já tá rolando. entra na lista de espera da comunidade e garante
          teu lugar quando o próximo desafio abrir.
        </p>
      </Reveal>
      <Reveal delay={150}>
        <div className="mt-10">
          <CtaButton label="entrar na lista de espera" main className="px-10 py-5 text-lg" />
        </div>
      </Reveal>
      <Reveal delay={260}>
        <p className="mt-14 text-lg font-bold tracking-[-0.02em]">
          escape do óbvio.
        </p>
      </Reveal>
    </div>

    <footer className="mt-20 border-t border-black/10 pt-8 text-center">
      <p className="text-xs text-black/40">
        © 2026 ESCAPE CLUB. todos os direitos reservados.
      </p>
    </footer>
  </section>
);

export default FinalCta;
